import { Button, Drawer, TextField } from '@mui/material';
import React, { useState } from 'react'

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';

import { CrudUsers } from '../../../api/admin/CrudUsers.api';
import { CrudSolicitudes } from '../../../api/admin/CrudSolicitudes.api';
import LoaderData from '../../../component/LoaderData';

export const Solicitudes = () => {

    const [IsLoadding, setIsLoadding] = useState(false);

        const [FechaInicio, setFechaInicio] = useState();
    
        const [usuariosList, setUsuariosList] = useState([]);
        const [usuariosListBKP, setUsuariosListBKP] = useState([]);

        const [DataSelected, setDataSelected] = useState();


    
        //DRAWER USUARIOS
        const [state_U, setState_U] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
        });
        const toggleDrawer_U = (anchor, open) => (event) => {
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
                return;
            }
            if(anchor === "bottom" && open){
                //LOGIC WHEN DRAWER CLOSER
            }
            setState_U({ ...state_U, [anchor]: open });
        };

        //CRUD SOLICITUDES
        const crudSolicitudes = (action, data) => {
    
            //logica para crud
            const createSolicitud = async (data) => {
            }
            const readSolicitud = async () => {
                setIsLoadding(true);
                let year = FechaInicio.split("-")[0]
                let semana = FechaInicio.split("-")[1].split("W")[1]
                let respSolicitud = await CrudSolicitudes({ data: {year:Number(year), semana:Number(semana)}, action: "READ" })
                // console.log(respSolicitud)
                await setUsuariosList(respSolicitud);
                await setUsuariosListBKP(respSolicitud);
                await setIsLoadding(false);
            }
            const updateSolicitud = async (data) => {
                setIsLoadding(true);
                // console.log("UPDATE", data)
                let idSolicitd = window.confirm("¿Esta seguro de editar la solicitud seleccionada?");
                if(idSolicitd) {
                    let resp = await CrudSolicitudes({data, action: "UPDATE"});
                    crudSolicitudes("READ");
                    alert("Solicitud editada correctamente");
                    let btn = document.createElement("button");
                    btn.setAttribute("type", "button");
                    btn.setAttribute("data-dismiss", "modal");
                    btn.click();
                    setDataSelected();
                }
                await setIsLoadding(false);
            }

            const deleteSolicitud = async (data) => {
                // console.log("DELETE", data)
                // let isDelete = window.confirm("¿Esta seguro de eliminar la solicitud seleccionada?");
                // if(isDelete) {
                //     let resp = await CrudSolicitudes({data, action: "DELETE"});
                //     crudSolicitudes("READ");
                //     alert("Solicitud eliminada correctamente");
                // }
            }
    
            switch (action) {
                case "CREATE":
                    createSolicitud(data);
                    return;
                case "READ":
                    readSolicitud();
                    return;
            
                case "UPDATE":
                    updateSolicitud(data);
                    return;
    
                case "DELETE":
                    deleteSolicitud(data);
                    return;
            }
        }
      
      return (<>
        <div className='container'>
            <div className='row'>
                <div className='col-12 fondo-celeste container-header-minipage mb-4 pt-3'>
                    <h1 className='lead text-white'><b>Solicitudes</b></h1>
                </div>
                <div className='col-12 mt-2'>
                    {/* buscador de usuario */}
                    <div className='row'>
                        <div className='col-12 col-md-4'>
                            <span className='fotmar-inp-date-label'>Fecha Inicio</span>
                            <input
                            defaultChecked={false}
                                type='week'
                                className='fotmar-inp-date'
                                // max={new Date().toISOString().split('T')[0]}
                                value={FechaInicio}
                                onChange={(e)=>setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div className='col-12 col-md-4 mt-4'>
                            <button disabled={!FechaInicio} className='btn btn-sm btn-outline-info' onClick={()=>crudSolicitudes("READ")}>
                                <SearchIcon />
                            </button>
                        </div>
                    </div>
                </div>
                <div className='col-12 mb-5'>
                    <div className='row' style={{width: "1600px"}}>
                    {
                        usuariosListBKP.length > 0 ?
                        usuariosListBKP.map((item, index) => 
                            <div className='divider-days' key={index}>
                                <div className='' style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                                    <div className='text-center bb-border' style={{width: '100%', backgroundColor:'black', color:'white'}}>{(item.fecha).split("-").reverse().join("-")}</div>
                                    {
                                        item.turnos.map((idItem, idIndex) =><div className='hover-cell bb-border'
                                            style={{width: '100%', display: 'flex', flexDirection: 'row'}}
                                            data-toggle="modal" data-target="#exampleModal"
                                            data-backdrop="static" data-keyboard="false"
                                            onClick={()=>setDataSelected(idItem)}
                                            key={idIndex}>
                                                <div className='' style={{width: '45%'}}>{idItem.rut}</div>
                                                <div className='' style={{width: '55%'}}>{idItem.turno}</div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        ):<div className='col-12'>
                            <span className='lead'>No hay usuarios para la semana seleccionada o debe seleccionar una semana para comenzar</span>
                        </div>
                    }
                       
                    </div>
                </div>
            </div>
        </div>

        {/* DRAWER PAR CREAR USUARIO */}
        <Drawer
            anchor={"bottom"}
            open={state_U["bottom"]}
            onClose={toggleDrawer_U("bottom", false)}
        >
            <div className='container-fluid mb-5'>
                <div className='row'>
                    <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                        <span className='lead'>EDITAR USUARIO</span>
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="NOMBRE"
                            variant="outlined"
                            placeholder='NOMBRE APELLIDO APELLIDO'
                            // value={Temperatura_P_selected?.CODPRODUCTO}
                            // onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, CODPRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="RUT"
                            variant="outlined"
                            // value={Temperatura_P_selected?.PRODUCTO}
                            // onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, PRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CORREO"
                            variant="outlined"
                            // value={Temperatura_P_selected?.MAQUINA}
                            // onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, MAQUINA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="AREA"
                            variant="outlined"
                            // value={Temperatura_P_selected?.N_OF}
                            // onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, N_OF:e.target.value.toUpperCase()})}
                        />
                    </div>
                

                    <div className='col-12 mt-2 text-right'>
                        <Button
                            variant="contained"
                            onClick={()=>crudDeTemperatura("UPDATE",Temperatura_P_selected)}>EDITAR</Button>
                    </div>
                </div>
            </div>
        </Drawer>

        {/* MODAL CAMBIO TURNO SOLICITADO */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Cambiar Solicitud de Usuario</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-12 py-2'>
                            <h5>Datos:</h5>
                                <span className=''>Usuario: {DataSelected?.rut}</span><br/>
                                <span className=''>Fecha: {DataSelected?.fecha}</span><br/><br/>
                            </div>
                        </div>
                        <TextField
                            focused
                            value={DataSelected?.turno}
                            onChange={(e)=>setDataSelected({...DataSelected, turno: e.target.value})}
                            fullWidth
                            id="outlined-basic"
                            size='small'
                            label="Nuevo Turno"
                            variant="outlined"
                        />
                        <small className='text-danger'>Ingrese un nuevo turno, si necesita anular la solicitud, ingrese <b>LIBRE</b>.</small>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            data-dismiss="modal"
                            onClick={()=>{
                                setDataSelected()
                            }}
                        >Cerrar</button>
                        <button
                            // disabled={cambioClave.length < 6}
                            type="button"
                            data-dismiss="modal"
                            className="btn btn-sm btn-danger"
                            onClick={()=>crudSolicitudes("UPDATE",DataSelected)}
                        >Guardar cambios</button>
                    </div>
                    </div>
                </div>
            </div>

        {
            IsLoadding &&  <LoaderData />
        }
      </>
      )
}
